import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';

import React, { useState } from 'react';
import {
  DELETE_VENDOR_BANKING_INFO_FAILURE,
  POST_VENDOR_BANKING_INFO_FAILURE,
  UPDATE_VENDOR_BANKING_INFO_FAILURE
} from 'modules/authorizations/store/types/dataManagementTypes';
import {
  updateVendorBankingInfo,
  postVendorBankingInfo,
  deleteVendorBankingInfo,
  getVendorBanksByVendorId
} from 'modules/authorizations/store/actions/dataManagement.actions';
import { flattenBanks } from './utils';
import BankingCardComponent from 'modules/common/bankingCard.component';

const VendorBankingInfoCard = props => {
  const [setIsLoading] = useState(false);

  const { vendorBanks, vendorId, isReadOnly, vendorAddress } = props;

  // Backend columns are NOT NULL, so text fields must be sent as strings and ints as numbers.
  const buildBankPayload = (values, existing = { vendorBank: {}, bank: {} }) => ({
    vendorBank: {
      ...existing.vendorBank,
      vendorId: vendorId,
      paymentCode: values.paymentCode ?? '',
      transitCode: values.transitCode ?? '',
      cuitCode: values.cuitCode ?? '',
      institutionNumber: values.institutionNumber ?? ''
    },
    bank: {
      ...existing.bank,
      statusId: values.statusId,
      accountLocationId: values.accountLocationId,
      accountTypeId: values.accountTypeId,
      bankName: values.bankName ?? '',
      bankCity: values.bankCity ?? '',
      bankPostal: values.bankPostal ?? '',
      bankProvinceId: values.bankProvinceId || '00000000-0000-0000-0000-000000000000',
      bankCountryId: values.bankCountryId,
      accountHolderName: values.accountHolderName ?? '',
      accountHolderAddressId: values.accountHolderAddressId ?? 0, 
      bankPhone: values.bankPhone ?? '',
      bankFax: values.bankFax ?? '',
      bankEmail: values.bankEmail ?? '',
      bankWebsite: values.bankWebsite ?? '',
      bankContactName: values.bankContactName ?? '',
      bankSwiftCode: values.bankSwiftCode ?? '',
      routingNumber: values.routingNumber ?? '',
      accountNumber: values.accountNumber ?? '',
      accountCurrencyId: values.accountCurrencyId,
      ibanNumber: values.ibanNumber ?? '',
      clabe: values.clabe ?? '',
      isDefaultAccount: values.isDefaultAccount === true,
      isPreferredForWire: values.isPreferredForWire === true,
      wireInstruction: values.wireInstruction ?? '',
      isPreferredForACH: values.isPreferredForACH === true,
      hasIntermedReqd: values.hasIntermedReqd === true,
      intermedBankingId: parseInt(values.intermedBankingId, 10) || 0,
      specialInstructions: values.specialInstructions ?? '',
      bankNickName: values.bankNickName ?? '',
      paymentTypeId: values.paymentTypeId,
      isPaymentByDueDate: values.isPaymentByDueDate === true,
      isPaymentByDiscountRate: values.isPaymentByDiscountRate === true,
      intermediaryBankName: values.intermediaryBankName ?? '',
      intermediarySwiftCode: values.intermediarySwiftCode ?? ''
    }
  });

  const updateBank = async (record, values) => {
    const existing = vendorBanks.find(b => b.vendorBank.vendorBankId === record.original.vendorBankId);
    const tempVal = buildBankPayload(values, existing);

    setIsLoading(true);
    const resp = await props.updateVendorBankingInfo(tempVal);
    setIsLoading(false);
    return resp.type !== UPDATE_VENDOR_BANKING_INFO_FAILURE;
  };

  const createBank = async values => {
    const tempVal = buildBankPayload(values);
    tempVal.vendorBank.bankId = 0;

    setIsLoading(true);
    const resp = await props.postVendorBankingInfo(tempVal);
    if (resp.type === POST_VENDOR_BANKING_INFO_FAILURE) {
      setIsLoading(false);
      return false;
    } else {
      setIsLoading(false);
      return true;
    }
  };

  const deleteBank = async record => {
    setIsLoading(true);
    const resp = await props.deleteVendorBankingInfo(record.original.vendorBankId);
    if (resp.type === DELETE_VENDOR_BANKING_INFO_FAILURE) {
      setIsLoading(false);
      return false;
    } else {
      setIsLoading(false);
      return true;
    }
  };

  return (
    <BankingCardComponent
      banks={flattenBanks(vendorBanks)}
      createBankFunc={createBank}
      updateBankFunc={updateBank}
      deleteBankFunc={deleteBank}
      isReadOnly={isReadOnly}
      isAuthorization={false}
      authorizationAddress={[vendorAddress]}
    />
  )
};

export default compose(
  connect(null, {
    updateVendorBankingInfo,
    postVendorBankingInfo,
    deleteVendorBankingInfo,
    getVendorBanksByVendorId,
    showToast
  })
)(VendorBankingInfoCard);
